// @flow

import React from 'react';
import './InputHelper.scss';

export const InputPreview = () => <div styleName="dnd-preview" />;


